import React from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useCurrentUser} from 'users/hooks'
import GuestBlockModal from 'ui/components/Modals/GuestUserBlockModal'
import {getGuestBlocked} from 'app/store/selectors'
import {setGuestBlocked} from 'app/store/actions'

const GuestBlock = () => {
  const user = useCurrentUser()
  const isGuestUser = !user
  const guestBlocked = useSelector(getGuestBlocked)
  const dispatch = useDispatch()

  const handleClose = () => dispatch(setGuestBlocked(false))

  return isGuestUser && (
    <GuestBlockModal open={guestBlocked} onClose={handleClose} />
  )
}

export default GuestBlock
